import { connectStepper } from "../util/redux";
import StopOrGo from "../components/stop-or-go";

export default connectStepper(StopOrGo);
